import React from 'react';

import { NextPage } from 'next';
import NextImage from 'next/image';

import { ExternalLink } from '../../components/Clickables/ExternalLink/ExternalLink';
import { Container } from '../../components/Container/Container';
import { Divider } from '../../components/Divider/Divider';
import { Grid } from '../../components/Grid/Grid';
import { Heading } from '../../components/Heading/Heading';
import { MetaTags } from '../../components/MetaTags/MetaTags';
import { Text } from '../../components/Text/Text';

import AboutImage1 from './assets/about_image_1.jpg';
import AboutHeaderImage from './assets/aboutus_fishbrain.jpg';
import AndroidHeadlinesImage from './assets/androidheadlines_fishbrain.png';
import TechcrunchImage from './assets/techcrunch_fishbrain.png';
import NytImage from './assets/TheNYT_fishbrain.png';

export const Mission: NextPage = () => (
  <Container>
    <MetaTags
      link="/mission"
      title="Our Mission"
      description="At Fishbrain, we&#39;re connecting anglers to make fishing dreams come true, today and
        tomorrow."
      image={AboutHeaderImage.src}
    />
    <div className="relative">
      <NextImage
        priority
        placeholder="blur"
        src={AboutHeaderImage}
        alt="Fishbrain angler"
        sizes="100vw"
      />
    </div>
    <div className="mx-auto mt-16 flex flex-col items-center">
      <Heading as="h1" variant="xs" className="mb-4 uppercase">
        Our Mission
      </Heading>
      <Heading as="p" variant="lg" className="mb-0 text-center">
        At Fishbrain, we&#39;re connecting anglers to make fishing dreams come true, today and
        tomorrow.
      </Heading>
    </div>

    <Divider variant="md" />

    <Grid className="my-16 content-center items-center">
      <div className="col-span-12 md:col-span-6">
        <div className="mb-4">
          <Heading variant="md" className="mb-2">
            Disrupting a tradition
          </Heading>

          <Text>
            Fishing is more than a hobby - it&#39;s a passion. Even if you don&#39;t personally love
            fishing, you definitely know someone who does. But we think there’s a way for technology
            to improve this age-old tradition. That’s why Fishbrain is changing the way people fish
            and how anglers connect. We’ve got big plans for the sport of fishing, and we’re backed
            by the investors behind some of the most successful social networks and apps. Get
            onboard and be part of the journey.
          </Text>

          <ExternalLink href="https://careers.fishbrain.com" variant="buttonPrimary">
            Learn more
          </ExternalLink>
        </div>
      </div>
      <div className="col-span-12 md:col-span-6">
        <NextImage
          placeholder="blur"
          src={AboutImage1}
          alt="About Fishbrain"
          sizes="(min-width: 990px) 50vw, 100vw"
        />
      </div>
    </Grid>

    <Divider variant="md" />

    <Heading variant="md" className="text-center uppercase">
      Making a splash
    </Heading>

    <Grid className="mb-16 mt-4 content-center items-center">
      <div className="col-span-12 text-center sm:col-span-4">
        <NextImage
          className="w-40"
          src={AndroidHeadlinesImage}
          alt="Android Headlines"
          width={160}
          height={160}
        />
      </div>
      <div className="col-span-12 text-center sm:col-span-4">
        <NextImage
          className="w-40"
          src={TechcrunchImage}
          alt="TechCrunch"
          width={160}
          height={160}
        />
      </div>
      <div className="col-span-12 text-center sm:col-span-4">
        <NextImage
          className="w-40"
          src={NytImage}
          alt="The New York Times"
          width={160}
          height={160}
        />
      </div>
    </Grid>
  </Container>
);
